import { FC, useEffect, useState } from 'react'
import { Toggle } from 'rsuite'
import './ToggleButton.scss'

type Props = {
  onToggle?: () => void,
  isActive?: boolean,
  children?: React.ReactNode
}
const ToggleButton: FC<Props> = ({
  children,
  onToggle,
  isActive = false
}: Props) => {
  const [isToggle, setIsToggle] = useState<boolean>(isActive)
  const onButtonClick = () => {
    setIsToggle(!isToggle)
    onToggle && onToggle()
  }
  useEffect(() => {
    setIsToggle(isActive)
  }, [isActive])
  return (
    <div className="card-toggle">
      <Toggle
        checked={isActive}
        onChange={onButtonClick}
        className={`toggle-button${isToggle ? ' toggle-button__active' : ''}`}
      >
        {children}
      </Toggle>
    </div>
  )
}
export default ToggleButton
